<template>
  <v-container>
    <v-card>
      <v-card-title
        class="headline lighten-2"
        primary
        title
      >{{$t('manage_email_receivers.email_receivers')}}</v-card-title>
      <v-card-text>
        <v-combobox
          v-model="model"
          :filter="filter"
          :hide-no-data="!search"
          :items="items"
          :search-input.sync="search"
          hide-selected
          label="Search for an option"
          multiple
          small-chips
          solo
        >
          <template v-slot:no-data>
            <v-list-tile>
              <span class="subheading">{{$t('manage_email_receivers.new_email')}}</span>
              <v-chip :color="`${colors[nonce - 1]} lighten-3`" label small>{{ search }}</v-chip>
            </v-list-tile>
          </template>
          <template v-slot:selection="{ item, parent, selected }">
            <v-chip
              v-if="item === Object(item)"
              :color="`${item.color} lighten-3`"
              :selected="selected"
              label
              small
            >
              <span class="pr-2">{{ item.text }}</span>
              <v-icon small @click="parent.selectItem(item)">close</v-icon>
            </v-chip>
          </template>
          <template v-slot:item="{ index, item }">
            <v-list-tile-content>
              <v-text-field
                v-if="editing === item"
                v-model="editing.text"
                autofocus
                flat
                background-color="transparent"
                hide-details
                solo
                @keyup.enter="edit(index, item)"
              ></v-text-field>
              <v-chip v-else :color="`${item.color} lighten-3`" dark label small>{{ item.text }}</v-chip>
            </v-list-tile-content>
            <v-spacer></v-spacer>
            <v-list-tile-action @click.stop>
              <v-btn icon @click.stop.prevent="edit(index, item)">
                <v-icon>{{ editing !== item ? 'edit' : 'check' }}</v-icon>
              </v-btn>
            </v-list-tile-action>
          </template>
        </v-combobox>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="save"
          >{{$t('manage_email_receivers.save')}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import User from "@/models/User.js";
export default {
  data() {
    return {
      activator: null,
      attach: null,
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      index: -1,
      items: [],
      nonce: 1,
      menu: false,
      model: [
      ],
      x: 0,
      search: null,
      y: 0,
      user: null
    };
  },

  watch: {
    model(val, prev) {
      if (val.length === prev.length) return;

      this.model = val.map(v => {
        if (typeof v === "string") {
          v = {
            text: v,
            color: this.colors[this.nonce - 1]
          };

          this.items.push(v);

          this.nonce++;
        }
        return v;
      });
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    async initialize() {
      const user = await User.loadMe();
      this.user = new User(user);
      if(this.user.company.manager_emails == null){
        return 0;
      }
      let managerEmails = this.user.company.manager_emails.split(',');
      let items = [];
      managerEmails.forEach(email => {
          items.push(email);
      });
      this.model = items;
    },

    save(){
        let managerEmails = "";
        this.model.forEach((email, index) => {
            managerEmails += email.text;
            if(this.model.length -1 != index){
                managerEmails += ","
            }
        });
        this.user.company.save({
          manager_emails: managerEmails
        });
    },

    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.index = index;
      } else {
        this.editing = null;
        this.index = -1;
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    }
  }
};
</script>

<style>
</style>